import React from 'react'
import PayoutRateContent from '../PayoutRate/PayoutRateContent'
import TermsAndConditions from '../TermsAndConditions/TermsAndConditions'

interface RulesProps {
  payoutRates: Parameters<typeof PayoutRateContent>[0]['payoutRates']
  termsContent: Parameters<typeof TermsAndConditions>[0]['children']
}

const Rules: React.FC<RulesProps> = ({ payoutRates, termsContent }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-[360px_1fr] gap-4 items-start">
      <PayoutRateContent payoutRates={payoutRates} />
      <TermsAndConditions>{termsContent}</TermsAndConditions>
    </div>
  )
}

export default Rules
